export default {
  jp: {
    title: {
      app: 'MEDIA PORTAL'
    }
  },
  en: {
    title: {
      app: 'MEDIA PORTAL'
    }
  }

}
